export const months = [
  { value: 1, stringVar: 'jan', label: 'January', label_short: 'Jan' },
  { value: 2, stringVar: 'feb', label: 'Febuary', label_short: 'Feb' },
  { value: 3, stringVar: 'mar', label: 'March', label_short: 'Mar' },
  { value: 4, stringVar: 'apr', label: 'April', label_short: 'Apr' },
  { value: 5, stringVar: 'may', label: 'May', label_short: 'May' },
  { value: 6, stringVar: 'jun', label: 'June', label_short: 'Jun' },
  { value: 7, stringVar: 'jul', label: 'July', label_short: 'Jul' },
  { value: 8, stringVar: 'aug', label: 'August', label_short: 'Aug' },
  { value: 9, stringVar: 'sep', label: 'September', label_short: 'Sep' },
  { value: 10, stringVar: 'oct', label: 'October', label_short: 'Oct' },
  { value: 11, stringVar: 'nov', label: 'November', label_short: 'Nov' },
  { value: 12, stringVar: 'dec', label: 'December', label_short: 'Dec' }
]

export const quarters = [
  { value: 1, stringVar: 'q1', label: 'First Quarter', label_short: 'Q1' },
  { value: 2, stringVar: 'q2', label: 'Second Quarter', label_short: 'Q2' },
  { value: 3, stringVar: 'q3', label: 'Third Quarter', label_short: 'Q3' },
  { value: 4, stringVar: 'q4', label: 'Last Quarter', label_short: 'Q4' }
]

export const biannuals = [
  { value: 1, stringVar: 'half1', label: 'First Half Year', label_short: '1st Half' },
  { value: 2, stringVar: 'half2', label: 'Second Half Year', label_short: '2nd Half' }
]

export const annuals = [{ value: 1, stringVar: 'year', label: 'Year', label_short: 'Year' }]
